const Partner = resolve => {
    require.ensure(['../views/apps/partner/Partner'], () => {
        resolve(require('../views/apps/partner/Partner'))
    })
};
const PartnerDetay = resolve => {
    require.ensure(['../views/apps/partner/PartnerDetay'], () => {
        resolve(require('../views/apps/partner/PartnerDetay'))
    })
};
const PartnerTanimla = resolve => {
    require.ensure(['../views/apps/partner/PartnerTanimla'], () => {
        resolve(require('../views/apps/partner/PartnerTanimla'))
    })
};
const PartnerListe = resolve => {
    require.ensure(['../views/apps/partner/PartnerListe'], () => {
        resolve(require('../views/apps/partner/PartnerListe'))
    })
};
const PartnerDuzenle = resolve => {
    require.ensure(['../views/apps/partner/PartnerDuzenle'], () => {
        resolve(require('../views/apps/partner/PartnerDuzenle'))
    })
};
const KategoriTanimlama = resolve => {
    require.ensure(['../views/apps/partner/kategori/KategoriTanimlama'], () => {
        resolve(require('../views/apps/partner/kategori/KategoriTanimlama'))
    })
};
import Vue from 'vue'

Vue.component('PartnerDetay', PartnerDetay);
Vue.component('PartnerTanimla', PartnerTanimla);
Vue.component('PartnerListe', PartnerListe);
Vue.component('partnerduzenle', PartnerDuzenle);
Vue.component('PartnerKategorileri', KategoriTanimlama);

import layouts from '../layout'

export default {
    path: '/partner',
    name: 'partner',
    component: Partner,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'partnerdetay',
            component: PartnerDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
